import React, { Component } from "react";

import CityXTeam_BannerTitle from "../layouts/about/team/CityXTeam_BannerTitle";
import CityXTeam_SideBar from "../layouts/about/team/CityXTeam_SideBar";
import CityXTeam_SiteContent from "../layouts/about/team/CityXTeam_SiteContent";

import { Header, Footer, TopBar, BottomBar } from "../layouts/general/index";
class CityXTeam extends Component {
  constructor(props) {
    super(props);
    this.state = {
      headers: [
        {
          id: 1,
          logoweb: "assets/img/logo-small.png",
          names: "About Us",
        },
      ],
      banners: [
        {
          id: 1,
          links: "/about-us",
          titlelink: "O nama",
          border: "|",
          name: " Upoznajte CityX Team",
          heading: "CityX Team",
        },
      ],
    };
  }
  render() {
    return (
      <div className="header-fixed page sidebar-right width-71 header-style-2 topbar-style-1 menu-has-search">
        <div id="wrapper" className="animsition">
          <div id="page" className="clearfix">
            <div id="site-header-wrap">
              <TopBar />
              {this.state.headers.map((data, idx) => (
                <Header data={data} key={idx} />
              ))}
            </div>
            {this.state.banners.map((data) => (
              <CityXTeam_BannerTitle key={data.id} data={data} />
            ))}
            <div id="main-content" className="site-main clearfix">
              <div id="content-wrap" className="container">
                <CityXTeam_SiteContent />
                <CityXTeam_SideBar />
              </div>
            </div>
          </div>
          <Footer />
          {this.state.headers.map((data, idx) => (
            <BottomBar data={data} key={idx} />
          ))}
        </div>
      </div>
    );
  }
}

export default CityXTeam;
